import type { ReactNode } from 'react';
import { css } from 'styled-system/css';
import { FooterSection } from './FooterSection';
import { Navigation } from './Navigation';

const NOISE_SVG =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")";

export function MarketingPage({ children }: { children: ReactNode }) {
  return (
    <div
      className={css({
        position: 'relative',
        minHeight: '100vh',
        background: 'bg.page',
        overflowX: 'clip',
      })}
    >
      <div
        aria-hidden="true"
        className={css({
          position: 'fixed',
          inset: 0,
          backgroundImage: NOISE_SVG,
          opacity: 0.03,
          pointerEvents: 'none',
          zIndex: 1,
        })}
      />
      <Navigation />
      <main
        className={css({
          position: 'relative',
          zIndex: 2,
          paddingTop: { base: '8', md: '10' },
        })}
      >
        {children}
      </main>
      <FooterSection />
    </div>
  );
}
